"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonWizardCollapsibleBreakpoints = exports.BronsonWizardItemTypes = void 0;
var BronsonWizardItemTypes;
(function (BronsonWizardItemTypes) {
    BronsonWizardItemTypes["DONE"] = "is-done";
    BronsonWizardItemTypes["DISABLED"] = "is-disabled";
    BronsonWizardItemTypes["ERROR"] = "is-error";
    BronsonWizardItemTypes["ACTIVE"] = "is-active";
    BronsonWizardItemTypes["REGULAR"] = "";
    BronsonWizardItemTypes["INACTIVE"] = "has-no-interaction";
})(BronsonWizardItemTypes = exports.BronsonWizardItemTypes || (exports.BronsonWizardItemTypes = {}));
var BronsonWizardCollapsibleBreakpoints;
(function (BronsonWizardCollapsibleBreakpoints) {
    BronsonWizardCollapsibleBreakpoints["SMALL"] = "s";
    BronsonWizardCollapsibleBreakpoints["MEDIUM"] = "m";
    BronsonWizardCollapsibleBreakpoints["LARGE"] = "l";
})(BronsonWizardCollapsibleBreakpoints = exports.BronsonWizardCollapsibleBreakpoints || (exports.BronsonWizardCollapsibleBreakpoints = {}));
